import { render } from "./app-form-invoice-product-item.vue?vue&type=template&id=c941ef0a&scoped=true"
import script from "./app-form-invoice-product-item.vue?vue&type=script&lang=js"
export * from "./app-form-invoice-product-item.vue?vue&type=script&lang=js"

import "./app-form-invoice-product-item.vue?vue&type=style&index=0&id=c941ef0a&scoped=true&lang=css"

import exportComponent from "/var/www/payje-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c941ef0a"]])

export default __exports__